export enum SalesOrderStatus {
    Created = 'STATUS_CREATED',
    Completed = 'STATUS_COMPLETED',
    CartPending = 'STATUS_CART_PENDING',
    Declined = 'STATUS_DECLINED',
    CompletedWithApproval = 'STATUS_COMPLETED_WITH_APPROVAL',
}
